module.exports = __webpack_public_path__ + "img/france-ischemic-heart-disease-female.1fc40594.png";